// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"a3bfd767","703":"02a70f2e"}[chunkId] + ".chunk.js";
};